import React, { useMemo } from "react";
import ProxyImage from "@/components/ProxyImage";
import OrderDTO from "@/dto/order/OrderDTO";
import EwaybillDTO from "@/dto/order/EwaybillDTO";
import { EwaybillOrderItemInfoParser } from "@/utils/EwaybillOrderItemInfoParser";

interface WithOrderItemsInfoProps {
    order: OrderDTO;

    orderItemsInfo?: EwaybillDTO["orderItemsInfo"];
}

/**
 * 订单部分打印的商品信息
 */
const WithOrderItemsInfo: React.FC<WithOrderItemsInfoProps> = function (props) {
    const { order, orderItemsInfo } = props;

    if (!orderItemsInfo) {
        return null;
    }

    const parsedOrderItemInfos = useMemo(() => EwaybillOrderItemInfoParser.parse(orderItemsInfo), [orderItemsInfo]);

    return (
        <div
            style={{
                width: 220,
            }}
        >
            <div
                className="mb5"
                style={{
                    color: "#000",
                }}
            >
                运单号打印的商品
            </div>

            {parsedOrderItemInfos.map((parsedOrderItemInfo, index) => {
                const orderItem = order?.orderItems?.find(
                    (orderItem) => orderItem.originalId === parsedOrderItemInfo.originalId,
                );

                if (!orderItem) {
                    return null;
                }

                return (
                    <div className="mb10" key={index}>
                        <div className="text-gray text-small mb5">{parsedOrderItemInfo.originalId}</div>

                        <ProxyImage src={orderItem.picture} style={{ width: 50, height: 50, objectFit: "contain" }} />

                        <span className="ml5">
                            {orderItem.localSkuProperties ??
                                orderItem.skuProperties ??
                                orderItem.simpleTitle ??
                                orderItem.title}
                        </span>

                        {parsedOrderItemInfo.quantity > 0 ? (
                            <span className="ml5">× {parsedOrderItemInfo.quantity}</span>
                        ) : (
                            <span className="ml5">(1/{Math.abs(parsedOrderItemInfo.quantity)}) × 1</span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(WithOrderItemsInfo);
